import { Link } from "react-router-dom";

const agreementText = `Индивидуальный предприниматель Тращевский Филипп Владимирович
(сайт https://thefeels.ru/)

Я, действуя свободно, своей волей и в своём интересе, даю согласие Индивидуальному предпринимателю Тращевскому Филиппу Владимировичу (ИНН 784804090474, ОГРНИП 321784700079246, сайт https://thefeels.ru/) на обработку моих персональных данных:
•	фамилия, имя, отчество (в объёме, предоставленном мной);
•	номер телефона.

Цели обработки
•	приём и обработка заявки на бронирование бильярдного стола;
•	связь со мной для подтверждения даты, времени и количества столов, уведомление о статусе бронирования;
•	исполнение договора оказания услуг (бронирование, предоставление доступа в клуб);
•	обратная связь, ответы на мои вопросы.

Перечень действий с персональными данными
Сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (только в случаях, предусмотренных законом или необходимых для исполнения обязательств передо мной), обезличивание, блокирование, удаление, уничтожение.

Обработка осуществляется как с использованием средств автоматизации, так и без таковой (бумажные носители).

Срок действия согласия и порядок его отзыва
Согласие действует в течение 3 (трёх) лет с даты его предоставления. Я уведомлён(а), что могу отозвать согласие в любой момент, направив письменное заявление на адрес электронной почты Оператора, указанный на сайте, или по юридическому адресу. Отзыв согласия не затрагивает законность обработки, произведённой до его получения.

С Политикой обработки персональных данных (размещена по адресу https://thefeels.ru/policy) ознакомлен(а) и полностью согласен(на).

`;

const AgreementPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-page-header">
        <Link to="/" className="back-button privacy-back">
          ✕
        </Link>

        <h1>Согласие на обработку персональных данных</h1>
      </div>

      <div className="info-card privacy-card">
        <div className="policy-content" style={{ whiteSpace: "pre-wrap" }}>
          {agreementText}
        </div>
      </div>
    </div>
  );
};

export default AgreementPage;
